import script from "./LeadsListView.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadsListView.vue?vue&type=script&setup=true&lang=js"

import "./LeadsListView.vue?vue&type=style&index=0&id=a8d2e08a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8d2e08a"]])

export default __exports__